module.exports = __webpack_public_path__ + "img/shoe4.43bbe442.svg";